<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <strong>{{ currentUserBind.account }}</strong>
      <img
        alt="User"
        :src="
          currentUserBind.infoAccount.anh_dai_dien
            ? currentUserBind.infoAccount.anh_dai_dien
            : 'img/user.png'
        "
        class="img-avatar"
      />
    </template>
    <template slot="dropdown">
      <b-card
        :no-body="true"
        footer-class="px-3 py-2"
        class="mb-0 header-card-account"
      >
        <b-card-body class="p-3 clearfix">
          <!-- <i class="icon-user bg-primary p-3 font-2xl mr-3 float-left"></i> -->
          <div class="mr-3 float-left">
            <img
              alt="User-Avatar"
              :src="
                currentUserBind.infoAccount.anh_dai_dien
                  ? currentUserBind.infoAccount.anh_dai_dien
                  : 'img/user.png'
              "
              class="img-avatar"
              width="50"
            />
          </div>
          <div></div>
          <div class="h6 text-info mb-0 mt-2 mb-1">
            {{ currentUserBind.infoAccount.name }}
          </div>
          <div class="font-xs text-muted text-uppercase bold-500">
            {{ currentUserBind.infoAccount.position }}
          </div>
        </b-card-body>
        <!-- <div slot="footer">
          <b-link
            class="font-weight-bold font-xs btn-block text-muted"
            @click="fn_gottoInFoAccount()"
          >
            Chi tiết thông tin cá nhân
            <i class="fa fa-angle-right float-right font-lg"></i>
          </b-link>
        </div> -->
      </b-card>
      <b-dropdown-item router-link to="/auth/changepassword">
        <i class="icon-key" />
        {{ aLang.header_goChangePassword }}
      </b-dropdown-item>
      <b-dropdown-item
        @click="fn_goToCient()"
        v-if="
          !(
            currentUser.roles.includes('Admin') ||
            currentUser.roles.includes('Officer')
          )
        "
      >
        <i class="icon-home" />
        Trang chủ
      </b-dropdown-item>
      <b-dropdown-item @click="fn_logoutToCient()">
        <i class="icon-logout" />
        {{ aLang.logout }}
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";

import AuthService from "../service/AuthService";
import LanguageService from "../service/LanguageService";
import ProfileApi from "../moduleApi/ProfileApi";
import DDATApi from "../moduleApi/DDATApi";
import MethodService from "../service/MethodService";
import ExtensionService from "../service/ExtensionService";
import config from "../config.json";

export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      itemsCount: 0,
      currentUser: MethodService.getCurrentUser(),
      currentUserBind: {
        account: "",
        infoAccount: {},
      },
    };
  },
  methods: {
    fn_logout() {
      this.$confirm(LanguageService.lang.logout, {
        confirmButtonText: LanguageService.lang.c_yes,
        cancelButtonText: LanguageService.lang.c_no,
        type: "info",
      })
        .then(() => {
          AuthService.logout(false)
            .then(() => {
              this.$message({
                showClose: true,
                message: this.aLang.logout_success,
                type: "success",
              });
              localStorage.clear();
              this.$router.push({ name: "Auth-Login" });
            })
            .catch(() => {
              this.$message({
                showClose: true,
                message: this.aLang.logout_error,
                type: "error",
              });
            });
        })
        .catch();
    },
    fn_logoutToCient() {
      this.$confirm(LanguageService.lang.logout, {
        confirmButtonText: LanguageService.lang.c_yes,
        cancelButtonText: LanguageService.lang.c_no,
        type: "info",
      })
        .then(() => {
          AuthService.logout(true)
            .then(() => {
              this.$message({
                showClose: true,
                message: this.aLang.logout_success,
                type: "success",
              });
              const lang = localStorage.getItem("lang") || "vi";
              const clientUrl =
                lang == "vi"
                  ? config.urlClient
                  : config.urlClientEn;
              localStorage.clear();
              window.location.href = clientUrl;
            })
            .catch(() => {
              this.$message({
                showClose: true,
                message: this.aLang.logout_error,
                type: "error",
              });
            });
        })
        .catch();
    },
    fn_goToCient() {
      const clientUrl =
        localStorage.getItem("lang") == undefined ||
        localStorage.getItem("lang") == "vi"
          ? config.urlClient
          : config.urlClientEn;
      window.location.href = clientUrl;
    },
    setToken(domain, qparams) {
      return `${domain}?${this.queryBuilder(qparams)}`;
    },
    queryBuilder(parameters) {
      if (typeof parameters === "string") return parameters;

      var query = [];
      for (var key in parameters) {
        if (parameters.hasOwnProperty(key)) {
          query.push(key + "=" + encodeURIComponent(parameters[key]));
        }
      }

      return query.join("&");
    },
    fn_setRole() {
      if (this.currentUser.roles.indexOf("BuiltinAdmin") != -1) {
        this.currentUser.infoAccount.position =
          "Quản trị hệ thống (BuiltinAdmin)";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "Super admin";
      }
      if (this.currentUser.roles.indexOf("Admin") != -1) {
        this.currentUser.infoAccount.position = "Quản trị hệ thống (Admin)";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "Admin";
      }
      if (this.currentUser.roles.indexOf("Officer") != -1) {
        this.currentUser.infoAccount.position = "Cơ quan quản lý (Officer)";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "Officer";
      }
      if (this.currentUser.roles.indexOf("TourAgent") != -1) {
        this.currentUser.infoAccount.position = "Công ty lữ hành (TourAgent)";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "TourAgent";
      }
      if (this.currentUser.roles.indexOf("TourGuide") != -1) {
        this.currentUser.infoAccount.position =
          "Hướng dẫn viên du lịch (TourGuide)";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "TourGuide";
      }
      if (this.currentUser.roles.indexOf("HqsManager") != -1) {
        this.currentUser.infoAccount.position =
          "Duyệt dịch vụ du lịch clc (HqsManager)";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "HqsManager";
      }
      if (this.currentUser.roles.indexOf("HqsContributor") != -1) {
        this.currentUser.infoAccount.position =
          "Đăng dịch vụ du lịch clc (HqsContributor)";
        this.currentUser.infoAccount.name = this.currentUser.infoAccount.name
          ? this.currentUser.infoAccount.name
          : "HqsContributor";
      }

      this.currentUser.infoAccount.nam = 123;
    },
    async fn_getAccount() {
      // this.currentUser =
      this.currentUser.infoAccount = {
        anh_dai_dien: "",
        email: "",
        name: "",
        phoneNumber: "",
        position: "",
      };

      try {
        let res = await ProfileApi.findById(this.currentUser.id);

        if (res.result) {
          this.currentUser.infoAccount = res.result;
          this.currentUser.infoAccount.name =
            res.result.ho_ten && res.result.ho_ten.ho_ten
              ? res.result.ho_ten.ho_ten
              : "";
          if (res.result.avatar_id) {
            this.currentUser.infoAccount.anh_dai_dien =
              ExtensionService.urlSurveyImg +
              res.result.avatar_id +
              "&r=square&w=512";
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.fn_setRole();
      }

      if (
        this.currentUser.roles &&
        this.currentUser.roles.indexOf("SafePlace") !== -1
      ) {
        try {
          let res = await DDATApi.list({
            filters: "nguoi_tao_id=" + this.currentUser.id,
            fields: "loai_diem_den,thong_tin_chung.anh,hoat_dong",
          });
          if (res.result && res.result.length > 0) {
            if (
              res.result[0].thong_tin_chung &&
              res.result[0].thong_tin_chung.anh
            ) {
              this.currentUser.infoAccount.anh_dai_dien =
                ExtensionService.urlSurveyImg +
                res.result[0].thong_tin_chung.anh +
                "&r=square&w=512";
            }
            if (
              res.result[0].hoat_dong &&
              res.result[0].hoat_dong.ngung_hoat_dong
            ) {
              if (
                window.location.pathname == "/admin/DuLieuAnToanHangNgay" ||
                window.location.pathname == "/admin/home"
              ) {
                this.$router.push({ name: "Admin-ThongTinDDAT-detail" });
              }
            }
            // else if (!('hotel,tourist_villa,tourist_apartment,tourist_cruise,motel,homestay'.includes(res.result[0].loai_diem_den))) {
            //   $(".fa-calendar-check-o").parent().hide();
            //   $(".icon-calendar").parent().hide();
            //   if (window.location.pathname == "/admin/DuLieuAnToanHangNgay") {
            //     this.$router.push({ name: "Auth-Page404" });
            //   }
            // }
            // else if (window.location.pathname == "/admin/home") {
            //   this.$router.push({ name: "Admin-LichBieuKBAT" });
            // }
          }
        } catch (error) {
          console.error(error);
        }
      }

      this.currentUserBind = this.currentUser;
    },
    fn_gottoInFoAccount() {
      this.$router.push({
        name: "Admin-NguoiDung-update",
        params: { id: this.currentUserBind.id },
      });
    },
  },
  created() {
    // this.fn_getAccount();
  },
  mounted() {
    this.fn_getAccount();
  },
};
</script>
